import type { FamilySearchIndexEntry } from "../../services/api/family";
import { formatChildGradeLabel } from "../../utils/parentFamilyHelpers";

/** "Thandi Mokoena" */
export const familyChildName = (entry: FamilySearchIndexEntry) =>
  `${entry.firstName} ${entry.lastName}`.trim();

/** "Grade 4 B", or just the parts the child has. */
export const familyChildGradeAndClass = (entry: FamilySearchIndexEntry) =>
  [entry.grade, entry.classSection].filter(Boolean).join(" ");

const searchKey = (text: string) => text.trim().replace(/\s+/g, " ").toLowerCase();

/**
 * Whether a child in the Organisation-wide family search index matches what's
 * typed: their name, student ID, grade or class. An empty search matches everyone.
 */
export function familyChildMatches(entry: FamilySearchIndexEntry, query: string): boolean {
  const q = searchKey(query);
  if (!q) return true;
  return [
    familyChildName(entry),
    entry.studentId ?? "",
    familyChildGradeAndClass(entry),
    // "Grade 4R" too, so "grade 4" finds a child saved as "4R".
    formatChildGradeLabel(entry) ?? "",
  ].some(
    (text) => searchKey(text).includes(q)
  );
}
